export default __webpack_public_path__ + "static/media/generic.c3ec75d1.svg";